//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CoolLightBox from "vue-cool-lightbox";
import Swiper from "swiper";
import InnerImageZoom from 'vue-inner-image-zoom';
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

export default {
  name: "ImageMainProduuctCard",
  props: {
    images: {
      type: Array,
    },
    promotion: {
      type: Object,
      default: null
    },
    productName: {
      type: String,
      default: "product",
    },
    productCategoryName: {
      type: String,
    }
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: "auto",
        loop: true,
        loopedSlides: 1,
        speed: 1000,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          bulletElement: "div",
          dynamicMainBullets: 0,
        },
        navigation: {
          prevEl: ".swiper-btn-prev",
          nextEl: ".swiper-btn-next",
        },
        // autoplay: {
          // delay: 5000,
          // disableOnInteraction: false,
          // waitForTransition: false,
        // },
      },

      activeIndexImage: null,

      zoomOptions: {
        max: 3,       // Максимальный уровень увеличения
        min: 0.1,      // Минимальный уровень увеличения
        increment: 0.1, // Шаг изменения зума
        mouseWheelZoom: true
      }
    };
  },
  components: {
    CoolLightBox,
    InnerImageZoom
  },
  computed: {
    imagesCoolLightBox() {
      return this.images.map((imageId) => {
        return this.$img(imageId.toString(), {width: 1900, bg: "fff"});
      });
    },
  },


  mounted() {
    this.initSlider();
  },

  methods: {
    getImgPath(imgId) {
      const imgPath = this.$img(String(imgId || "0"), {
        width: "645",
        height: "365",
      });

      return String(imgPath);
    },
    getLargeImgPath(imgId) {
      const imgPath = this.$img(String(imgId || "0"), {
        width: "1200",
        height: "700",
      });

      return String(imgPath);
    },
    getAlt(id) {
      return `${this.productCategoryName} ${this.productName}`
      // ${id || ''}
    },
    initSlider() {
      if (this.images.length <= 1) {
        return null;
      }

      this.swiper = new Swiper(".product-slider-images", {
        ...this.swiperOptions,
      });
    },
  },
};
